import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { Socket } from './../shared/interfaces';
import { Howl } from 'howler';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  socket: Socket;
  draftUrl: string;
  private _settingURL = `${environment.phpApiUrl}` + '/settings/get-detail/' + `${environment.DRAFT_ACCESS_TOKEN}`;
  private _userTeamURL = `${environment.phpApiUrl}` + '/user/teams/' + `${environment.DRAFT_ACCESS_TOKEN}`;
  myTeamcursor = 0;
  lastStatus = 'drafting';
  myTeamPlayers = new EventEmitter();
  httpOptions = { headers: new HttpHeaders({}) };
  
  constructor(private http: HttpClient, private _utilsService: UtilsService) {
    if (localStorage.getItem('currentUser') == null) {
      window.location.href = `${environment.SITE_URL}/logout`;
    }
    this.draftUrl = `${environment.draftUrl}`;
  }

  getSetting(): Observable<any> {
    return this._utilsService.getRequest(this._settingURL);
  }

  getFAQTitles(): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/getFAQTitles/' + `${environment.DRAFT_ACCESS_TOKEN}`);
  }

  getFAQItem(id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/getFAQItem/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + id);
  }

  searchFAQ(search): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/searchFAQ/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + search);  
  }

  getActiveDraft(user_id, game_id): Observable<any> {
    return this._utilsService.getRequest(this.draftUrl + '/getAllTournamentRecords/' + user_id + '/' + game_id);
  }

  getActiveLeague(user_id, cursor): Observable<any> {
    return this._utilsService.getRequest(this.draftUrl + '/loadLeagueListRecords/' + user_id + '/' + cursor);
  }

  getTeam(user_id, status, cursor: number): Observable<any> {
    const key = '0';
    const player = '0';
    const sport = 'all';
    const duration = 'all';
    const direction = '0';
    const limit = '8';
    const order = '0';

    if (this.myTeamcursor < 1 || this.lastStatus !== status || cursor === 0) {
      this.myTeamcursor = 0;
      this.lastStatus = status;
    }


    const TeamURL = this._userTeamURL + '/' + user_id + '/' + key + '/' + player + '/' + sport + '/' + duration + '/' + status + '/' + this.myTeamcursor + '/' + order + '/' + direction + '/' + limit;
    return this.http
      .get<any>(TeamURL, this.httpOptions)
      .pipe(
        map(res => {
          this.myTeamcursor++;
          return res;
        })
      );
  }

  getPlayerInfoData(player_id, season_id, league_id, league_team_id, abbr, draft_status, tab_name): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/player/player-info/' + `${environment.DRAFT_ACCESS_TOKEN}` +
    '/' + player_id + '/' + season_id + '/' + league_id + '/' + league_team_id + '/' + abbr + '/' + draft_status + '/' + tab_name);
  }

  playSound() {
    const sound = new Howl({
      src: [`${environment.assetURL}` + '/assets/default/media/cool-notifications.mp3'],
      autoplay: true,
      loop: false,
      volume: 1.0,
      onend: function () {
      }
    });
  }

  headerNotification(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/settings/header-notification/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }
  
  userDetail(user_id = 0,token = null) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/profile/' + `${environment.DRAFT_ACCESS_TOKEN}`);
  }

  getCurrentlyWinning(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/getCurrentlyWinning/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }
  
  sendOTP(phone: String) {
    return this._utilsService.getRequest(`${environment.phpUrl}` + '/register/send-verification/'+phone);
  }

  verifyOTP(phone: String, otp: String) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/checkVerification/'+`${environment.DRAFT_ACCESS_TOKEN}`+'/'+phone+'/'+otp);
  }
  
  acceptFriendRequest(request_uuid, user_id) {
    var data = {
      'request_uuid': request_uuid,
      'user_id': user_id,
      'access_token': `${environment.DRAFT_ACCESS_TOKEN}`,
    }
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/friends/accept-request', data, null, 'content-type-json');
  }
  
  rejectFriendRequest(request_uuid,user_id) {
    var data = {
      'request_uuid': request_uuid,
      'user_id': user_id,
      'access_token': `${environment.DRAFT_ACCESS_TOKEN}`,
    }
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/friends/reject-request', data, null, 'content-type-json');
  }

  friendList(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/friends/getallfriendlist/' + `${environment.DRAFT_ACCESS_TOKEN}` +'/'+user_id);
  }

  addNewMessage(data) {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/friends/addnewmsgallfriends', data, null, 'content-type-json');
  }

  getPicture(img, type,user_id){
    var imagepath = '';
    if (img) {
      switch (type) {
        case 'users':
          var path = img.split('/');
          if (path.length >= 2 && path[path.length - 2] == "preset") {
            imagepath = `${environment.assetURL}` + '/assets/default/images/' + path[path.length - 2] + '/' + path[path.length - 1];
          } else if (path[path.length - 1] == 'user.png') {
            imagepath = `${environment.assetURL}` + '/assets/default/images/user.png';
          } else {
            imagepath = `${environment.assetURL}` + '/assets/uploads/users/' + user_id + '/profile/image_50x50/' + path[path.length - 1];
          }
          break;
        case 'players':
          imagepath = `${environment.assetURL}` + '/assets/uploads/players/' + img;
          break;
        case 'gameIcon':
          imagepath = `${environment.assetURL}` + '/assets/default/images/' + img;
          break;
      }
    }
    return imagepath;
  }

  getTiersData(league_id, user_id, lgm_id){
    return this._utilsService.getRequest(`${environment.boxScoreUrl}` + '/getPickemData/' + league_id + '/' + user_id + '/' + lgm_id);
  }

  saveTiersRoster(league_id, lgm_id, game_id, roster){
    const data = {
      lg_id: league_id,
      lgm_id,
      game_id,
      roster,
      angular: 1
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/league/pickem', data, null, 'content-type-json');
  }
  
  saveRankemRoster(league_id, lgm_id, game_id, roster){
    const data = {
      lg_id: league_id,
      lgm_id,
      game_id,
      roster,
      angular: 1
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/league/rankem', data, null, 'content-type-json');
  }
  rankemQuickJoin(lg_abbr, default_set, user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/rankem/quick-join/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + lg_abbr + '/' + default_set + '/' + user_id);
  }
  
  tiersQuickJoin(lg_abbr, default_set, user_id, drafttype_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/pickem/quick-join/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + lg_abbr + '/' + default_set + '/' + user_id + '/' + drafttype_id);
  }

  private handleErrorPost<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(result); // log to console instead 
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  getImageData(urls): Observable<any> {
    let data = {'urls':urls};
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/util/getImageData', data, null, 'content-type-json');
}
}